import { render, staticRenderFns } from "./EditHospitalisation.vue?vue&type=template&id=923a2902&scoped=true"
import script from "./EditHospitalisation.vue?vue&type=script&lang=js"
export * from "./EditHospitalisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923a2902",
  null
  
)

export default component.exports